import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { AutocompleteComponent } from '../../components/autocomplete/autocomplete.tsx';
import './home-page.scss';
import { useNavigate, useSearchParams } from 'react-router';
import { useGetCurrentUser } from '../../hooks/auth.ts';
import { AuthDialog } from '../auth-dialog/auth-dialog.tsx';
import { useAutocomplete } from '../../hooks/use-autocomplete.ts';
import { useTitle } from '../../hooks/useTitle.ts';

export const HomePageView = () => {
  useTitle('Immersive Homes');
  const [urlSearchParams] = useSearchParams();
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const navigate = useNavigate();

  const signInParam = urlSearchParams.get('sign-in');
  const { data: user } = useGetCurrentUser();
  const autoCompleteProps = useAutocomplete();

  useEffect(() => {
    if (signInParam) {
      setOpenAuthModal(true);
    }
    if (user?.userId) {
      urlSearchParams.delete('sign-in');
      setOpenAuthModal(false);
      void navigate('/');
    }
  }, [navigate, openAuthModal, signInParam, urlSearchParams, user?.userId]);

  const handleCloseModal = () => {
    urlSearchParams.delete('sign-in');
    setOpenAuthModal(false);
    void navigate('/');
  };

  return (
    <Box data-testid="home-page" className="home-page">
      <Box className="container">
        <Typography className="text" data-home-page-title>
          Let's Find a Homesite
        </Typography>
        <Box className="search">
          <AutocompleteComponent
            {...autoCompleteProps}
            placeholder="Search by address, zip and more"
          />
        </Box>
      </Box>
      <AuthDialog
        open={openAuthModal}
        onClose={() => handleCloseModal()}
        payload="login"
      />
    </Box>
  );
};


